var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowRightDisable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 20,
    viewBox: "0 0 13 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6_7",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 13,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.31 0H0V19.39H12.31V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6_7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.77101 6.67069C8.67101 5.61069 5.96101 2.96069 3.31101 0.520687L3.06101 0.290687L2.83101 0.130687C2.46101 -0.0993126 2.34101 -0.00931254 1.99101 0.240687C1.46101 0.630687 1.53101 0.540687 1.18101 1.10069C1.04101 1.32069 0.961011 1.59069 1.02101 1.85069C1.08101 2.12069 1.14101 2.20069 1.32101 2.39069C1.52101 2.58069 3.75101 4.75069 7.64101 8.96069C7.64101 8.96069 9.59101 11.1707 7.47101 12.4607C3.93101 14.6107 1.93101 15.1907 0.391011 16.0007C0.131011 16.1407 0.0210106 16.3207 0.0210106 16.4007C-0.00898945 16.5807 -0.0389894 16.9407 0.0610106 17.2407C0.321011 18.0007 0.871011 18.3507 1.39101 18.9507C1.72101 19.3407 1.83101 19.5107 2.27101 19.2607C4.51101 18.0207 9.42101 15.4907 10.251 15.0107C13.841 12.9707 12.071 8.90069 9.76101 6.66069L9.77101 6.67069Z",
    fill: "#DDD7D3"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightDisable);
export default __webpack_public_path__ + "static/media/arrow-right-disable.15633f37de0a5efc08948ca96a6356f6.svg";
export { ForwardRef as ReactComponent };